<nz-date-picker
  [formlyAttributes]="field"
  [formControl]="formControl"
></nz-date-picker>
